export const normalizeNumberToTimeHoursFormat = (v: number) => {
  return v.toString().padStart(2, '0');
};
